/**
 * Triggers a file download in the browser for both same-origin and cross-origin URLs (including Cloudinary).
 */
export async function triggerFileDownload(url: string, filename?: string): Promise<void> {
  if (!url) return;

  const targetFilename = filename || url.split('/').pop()?.split('?')[0] || 'download';

  // 1. If it's a Cloudinary URL, insert fl_attachment flag to force Content-Disposition attachment header
  if (url.includes('/upload/') && !url.includes('fl_attachment')) {
    const downloadUrl = url.replace('/upload/', '/upload/fl_attachment/');
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', targetFilename);
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    link.remove();
    return;
  }

  // 2. Fetch blob and trigger download via object URL for CORS-enabled resources
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error ${response.status}`);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', targetFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.warn('Blob fetch failed, falling back to direct link download:', err);
    // Fallback: direct anchor trigger
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.setAttribute('download', targetFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
